import { render } from "./Root.vue?vue&type=template&id=8e074daa&scoped=true"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=8e074daa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8e074daa"

export default script